<div class="flex">
    <div class="tag tag-{{type}} font-medium text-xs" [innerHTML]="text"></div>
</div>